import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerEmailAktualisierenAdmin laden';
export const POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerEmailAktualisierenAdmin ausführen';
export const POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerEmailAktualisierenAdmin laden erfolgreich';
export const POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerEmailAktualisierenAdmin Ladefehler';
export const POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerEmailAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerEmailAktualisierenAdminAction implements Action {
    readonly type = POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN;
        constructor(public benutzerEmailAktualisierenRequest: api.BenutzerEmailAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEmailAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerEmailAktualisierenRequest: api.BenutzerEmailAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEmailAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerEmailAktualisierenRequest: api.BenutzerEmailAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEmailAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerEmailAktualisierenRequest: api.BenutzerEmailAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEmailAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_EMAIL_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerEmailAktualisierenAdminActions =
    PostBenutzerEmailAktualisierenAdminAction
    | PostBenutzerEmailAktualisierenAdminAusfuehrenAction
    | PostBenutzerEmailAktualisierenAdminErfolgreichAction
    | PostBenutzerEmailAktualisierenAdminFehlerAction
    | PostBenutzerEmailAktualisierenAdminNichtAusgefuehrtAction
    ;
